module.exports = __webpack_public_path__ + "img/toyota-logo-vector.fed8d83b.png";